import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import Checkbox from '@material-ui/core/Checkbox';
import setting from '../../../config/setting'
import Button from '@material-ui/core/Button'
import {styles} from '../../CSS/Styles';
import CustomizedLineChart from '../../CSSComponent/linechart'
import {KRIAlertChartDataFormationfloodingDetail} from '../../SharedComponents/KRIAlertChartDataFormation'
import Typography from '@material-ui/core/Typography';

class prediction extends Component {
    constructor(props) {
        super(props)
    }

//
    render() {
        const { classes } = this.props
        if (this.props.date == null) {
            return(<div/>)
        }
        console.log(this.props.date)
        let floodingdetail = KRIAlertChartDataFormationfloodingDetail(this.props.data, this.props.threshold, this.props.date)
        console.log(floodingdetail)
        return (
            <div>
                <CustomizedLineChart data={floodingdetail} title={[floodingdetail.risk_name, floodingdetail.kri_id + ' -- ' + floodingdetail.description]}/>
                <Button
                    variant='outlined'
                    color='primary'
                    className={classes.button}
                    style={{position:'absolute', top:'0px',left:'0px'}}
                    onClick={() => {
                        console.log('bakc')
                        this.props.back()
                    }}
                >
                    Back
                </Button>
            </div>
        )
    }
}
export default withStyles(styles)(prediction)


// WEBPACK FOOTER //
// ./src/components/Dashboard/KRIDashboardComponent/KRIFloodingPredictionDetail.js